import {Injectable} from '@angular/core';
import {NewsEntitiesEffects} from '../../../../store/effects/news-entities.effects';
import {OverviewActions} from './overview.actions';


@Injectable()
export class OverviewEffects {

  constructor(
    private _newsEntitiesEffects: NewsEntitiesEffects,
  ) {
  }

  readonly readNews$ = this._newsEntitiesEffects.readNews$(
    OverviewActions.readNews,
    OverviewActions.readNewsSuccess,
    OverviewActions.readNewsFailure,
  );

}
